import React from "react";
import { Box, Button, Text } from "@showitinc/showit-wc";
import AssetUtils from "../../../utils/AssetUtils";
import { getAssetFileNameFromKey } from "../../../utils/AssetNameUtils";
import useUserAssets from "../../../hooks/query/useUserAssets";
import styles from "./AssetPreview.module.css";
import ImgIcon from "../element/image/ImgIcon";

const AssetPreview = ({ disabled, onSelect, value }) => {
  const { assets } = useUserAssets();
  const clickHandler = !disabled ? onSelect : null;

  const key = value ? value.get("key") : "";
  const provider = value ? value.get("provider") : undefined;
  const assetLabel = key ? getAssetFileNameFromKey(assets, key) : "";

  if (!key) {
    return (
      <div className={`${styles["asset-select-wrapper"]}`} onClick={clickHandler}>
        <ImgIcon className={styles["asset-placeholder"]} />
      </div>
    );
  }

  return (
    <>
      <div
        className={`${styles["asset-select-wrapper"]} ${disabled ? styles.disabled : ""}`}
        onClick={clickHandler}
      >
        <div
          data-testid="asset-preview-image"
          className={styles["asset-preview"]}
          style={{ "--preview": `url("${key && AssetUtils.getV2PreviewURL(key, { provider })}")` }}
        >
          &nbsp;
        </div>
      </div>
      <Box mx="3" mb="2">
        <Button
          variant="text"
          lowercase
          onClick={clickHandler}
          className={styles["filename-button"]}
          disabled={disabled}
        >
          <Text className={styles["filename-text"]}>{assetLabel}</Text>
        </Button>
      </Box>
    </>
  );
};

export default AssetPreview;
